import { StoreInformationServiceModule } from 'services/data/storeInformation.service';
import assign from 'lodash/assign';
import template from './seo.html';
import './seo.scss';

export const SeoExtensionModule = angular
    .module('app.components.extensions.seo', [StoreInformationServiceModule])
    .component('seo', {
        template,
        bindings: {
            model: '='
        },
        controller: class Seo {
            constructor(storeInformationService, $translate, $location) {
                assign(this, { storeInformationService, $translate, $location });
            }

            $onInit() {
                const ctrl = this;
                this.storeInformationService.getStore()
                    .then((store) => {
                        return this.formatExampleUrl(store);
                    })
                    .then((storeUrl) => {
                        ctrl.storeUrl = storeUrl;
                        return ctrl.$translate('SEO.HINT', {});
                    })
                    .then((message) => {
                        ctrl.hint = message;
                    });
            }

            formatExampleUrl(store) {
                let storeUrl = store.customDomain || store.storeUrl;
                if (storeUrl[storeUrl.length - 1] !== '/') {
                    storeUrl += '/';
                }
                const type = this.$location.$$path.split('/')[1];

                switch (type) {
                    case 'category':
                        storeUrl += 'c/';
                        break;
                    case 'product':
                        storeUrl += 'p/';
                        break;
                    case 'pages':
                        storeUrl += 'page/';
                        break;
                    default:
                        break;
                }
                return storeUrl;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/extensions/seo/seo.directive.js